import type { Reactive } from 'vue';
import type { ListingPageContext } from '#layers/block-engine';
import { reactiveComputed } from '@vueuse/core';
import { useBlockContext } from '#layers/block-engine';
import { blockContextIsListingPage } from '~/utils/block';

export function useListingPageContext(): Reactive<ListingPageContext & { isListingPage: boolean }> {
	const { getRootContext } = useBlockContext();

	return reactiveComputed(() => {
		const rootContext = getRootContext();
		return {
			...rootContext as ListingPageContext,
			isListingPage: blockContextIsListingPage({ getRootContext }),
		};
	});
}
